module.exports = __webpack_public_path__ + "img/335.ba690629.png";